export default {"src":"/_next/static/media/ABSI.a6352620.svg","height":18,"width":18};